<template>
    <div class="bg">
        <div class="white-frame">
            <div class="text-center"><img src="/static/img/logo.png" class="mb-3"></div>
            <p>&nbsp;</p>
            <h4 class="text-center mb-3">Page not found</h4>

            <p class="text-center">Sorry, the page you're trying to access can't be found.</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <b-button id="btn-home" class="btn-orange mt-4 mb-3" size="lg" :block="true">
                <i class="dripicons-home mr-2"></i>Go home
            </b-button>
        </div>
    </div>
</template>

<script>
  import {Form} from 'bootstrap-vue/es/components';
  import {FormGroup} from 'bootstrap-vue/es/components';
  import {FormCheckbox} from 'bootstrap-vue/es/components';
  import {Button} from 'bootstrap-vue/es/components';

  export default {
    name: "ForgotPassword",
    components: {
      Form,
      FormGroup,
      Button
    }
  }
</script>

<style scoped>
    .bg {
        background-image: url('/static/img/login_bg.jpg');
        background-size: cover;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .white-frame {
        width: 60%;
        max-width: 100%;
        min-height: 500px;
    }

    #btn-home {
        max-width: 200px;
        margin: auto;
    }
</style>


// WEBPACK FOOTER //
// src/views/NotFound.vue